import React, { useEffect, useState } from 'react';
import {Routes, Route} from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";

import AddNSE from './components/AddNSE';
import NSEDataTable from './components/NSEDataTable';
import EditNSE from './components/EditNSE';
import HomePage from './components/Home';
import HomePageContent from './components/HomePageContent';
import LineChartComponent from './NSEChart';

function App() {
  return (
    <HomePage>
      <Routes>
        <Route exact path="/" element={<HomePageContent/>} />
        <Route exact path="/nsedetails" element={<NSEDataTable/>} />
        <Route exact path="/addnse" element={<AddNSE/>} />
        <Route path="/editnse/:id" element={<EditNSE/>} />
        <Route path="/nsechart" element={<LineChartComponent/>} />
      </Routes>
    </HomePage>
  );
};

export default App;